import { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/core/hooks/useAuth";
import { whatsappHealthApi } from "../api/whatsappHealthApi";

export const whatsappHealthQueryKey = (sectorId: string) =>
  ["whatsapp-health", sectorId] as const;

export function useSectorWhatsAppHealth(
  sectorId: string | null | undefined,
  opts?: { enabled?: boolean }
) {
  const { token } = useAuth();
  const forceRefreshRef = useRef(false);

  const query = useQuery({
    queryKey: whatsappHealthQueryKey(sectorId ?? ""),
    queryFn: async () => {
      const refresh = forceRefreshRef.current;
      forceRefreshRef.current = false;
      return refresh
        ? whatsappHealthApi.getHealth(sectorId as string, token, true)
        : whatsappHealthApi.getHealth(sectorId as string, token);
    },
    enabled: !!sectorId && opts?.enabled !== false,
    // A saúde muda do lado da Meta sem evento no socket (o `sector_state` só
    // sai quando o setor é gravado), então o foco continua refazendo; com 5 min
    // de frescor em vez de 1, o alt-tab deixa de ir ao servidor a cada minuto
    // (SA-1452).
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: true,
  });

  const refresh = async () => {
    if (!sectorId) return;
    forceRefreshRef.current = true;
    const result = await query.refetch();
    return result.data;
  };

  return { ...query, refresh };
}
